import React from "react";
import "./EditorialWidget.scss";
import clsx from "clsx";
import { Section } from "../Section";
import { Col } from "../Col";

export enum EditorialWidgetVariantEnum {
  LIGHT = "light",
  EVIDENCE = "evidence",
  DEFAULT = "default",
}

export type EditorialWidgetProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  variant: EditorialWidgetVariantEnum;
  maxWidth?: string;
};

export function EditorialWidget({
  title,
  children,
  subtitle,
  variant = EditorialWidgetVariantEnum.DEFAULT,
  maxWidth,
}: EditorialWidgetProps) {
  return (
    <Section
      className={clsx("editorial-widget", variant)}
      style={maxWidth ? { maxWidth } : undefined}
    >
      <Col className="">
        {title && (
          <Section.Title fs="3" className="title" mdFs="3">
            {title}
          </Section.Title>
        )}
        {subtitle && <div className="subtitle">{subtitle}</div>}
        {children && (
          <Section.Description color="transparent">
            {children}
          </Section.Description>
        )}
      </Col>
    </Section>
  );
}
